import React from 'react'
import { Tabs, Tab, BottomNavigation, BottomNavigationAction, useMediaQuery } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import PeopleIcon from '@mui/icons-material/People'
import TuneIcon from '@mui/icons-material/Tune'
import DI from './utility/DI'

const Navigators = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const isMobile = useMediaQuery('(max-width:600px)');
  const {
    di: { session },
  } = props;

  const hasHomes = session?.homes?.length > 0;

  // Normalize path for tab selection (e.g. /panel/manage?section=... or /home/add -> /panel/manage)
  const tabValue = currentPath.startsWith('/panel/manage') || currentPath.startsWith('/home/add')
    ? '/panel/manage'
    : currentPath;

  const handleChange = (event, newValue) => {
    // If user clicks Home tab but has no homes, redirect to manage page to create one
    if (newValue === "/home" && !hasHomes) {
      navigate("/panel/manage?section=homes");
      return;
    }
    navigate(newValue);
  };

  return (
    <div style={{ marginBottom: `10px` }} key={currentPath}>
      {isMobile ? (
        <BottomNavigation value={tabValue} onChange={handleChange} showLabels>
          <BottomNavigationAction
            id="nav-shared-expenses"
            label="Shared"
            value="/panel"
            icon={<PeopleIcon />}
          />
          <BottomNavigationAction
            id="nav-home-expenses"
            label="Home"
            value="/home"
            icon={<HomeIcon />}
          />
          <BottomNavigationAction
            id="nav-manage"
            label="Manage"
            value="/panel/manage"
            icon={<TuneIcon />}
          />
          <BottomNavigationAction
            id="nav-add-friend"
            label="Add Friend"
            value="/panel/friends"
            icon={<GroupAddIcon />}
          />
        </BottomNavigation>
      ) : (
        <Tabs
          value={tabValue}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="main navigation tabs"
          style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}
        >
          <Tab
            id="nav-shared-expenses"
            label="Shared Expenses"
            value="/panel"
            icon={<PeopleIcon />}
            iconPosition="start"
          />
          <Tab
            id="nav-home-expenses"
            label="Home Expenses"
            value="/home"
            icon={<HomeIcon />}
            iconPosition="start"
          />
          <Tab
            id="nav-manage"
            label="Manage"
            value="/panel/manage"
            icon={<TuneIcon />}
            iconPosition="start"
          />
          <Tab
            id="nav-add-friend"
            label="Add Friend"
            value="/panel/friends"
            icon={<GroupAddIcon />}
            iconPosition="start"
          />
        </Tabs>
      )}
    </div>
  )
}

export default DI(Navigators)